import {nav} from "./nav";

/**
 * Ajax-Script for sending contact requests from global contact form
 */
export const form = {
  /**
   * Init Contact Form
   */
    init: function () {
        jQuery(function ($) {
            $('[id^=ajax_contact_form]').submit(function (e) {
                e.preventDefault();
                const form = $(this);
                const $btn = $(this).find('button');
                $btn.button('loading');
                $.post(ajax_object.ajaxurl, {
                    action: 'ajax_action',
                    data: $(this).serialize(),
                }, function ( response ) {
                  // alert(response);

                    let array = jQuery.parseJSON(response);
                    let formResult = '';

                  // If name is missing
                    if (array.name) {
                      // alert('NO!' + array.name);
                        formResult += array.name + '<br>';
                    }

                  // If eMail is missing
                    if (array.email) {
                      // alert('NO!' + array.name);
                        formResult += array.email + '<br>';
                    }

                  // If message is missing
                    if (array.message) {
                      // alert('NO!' + array.name);
                        formResult += array.message + '<br>';
                    }


                    if (array.success) {
                      // Hide form & button on success
                        form.find(".field").hide();
                        $btn.hide();

                      // alert(array.notice);

                      // Add notice about sent message
                        formResult += array.notice;
                        form.find(".form_result").addClass('success');

                        setTimeout(nav.closePanel, 2000);
                    }

                    form.find(".form_result").html(formResult);

                    $btn.button('reset');

                });
            });
        });
    },
};
